import axios from "axios";

axios.defaults.withCredentials = true;

const baseURL = "/api/candidatures-archives";

export default {
  /**
   * Récupérer une liste de candidatureArchive paginée coté backend
   */
  async getCandidaturesArchives(params) {
    return (await axios.get(baseURL, { params })).data;
  },

  /**
   * Récupérer une liste de pieceArchive pour une candidatureArchive donnée
   */
  async getCandidatureArchivePieces(candidatureArchiveId) {
    const response = await axios.get(
      `${baseURL}/${candidatureArchiveId}/pieces`
    );
    return response.data;
  },

  /**
   * Télécharger une pieceArchive
   */
  async telechargerPiece(candidatureArchiveId, pieceArchiveId) {
    const response = await axios.get(
      `${baseURL}/${candidatureArchiveId}/pieces/${pieceArchiveId}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  },
};
